var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4A4A4F",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Planet_sustainability"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.09,114.26c-78.18,0-141.78,63.61-141.78,141.79s63.6,141.79,141.78,141.79,141.79-63.61,141.79-141.79S332.28,114.26,254.09,114.26ZM130.31,256.05A123,123,0,0,1,146,195.77a87.75,87.75,0,0,0,45.81,12.46c42.14,0,76.3-27.8,76.3-62.08a51.19,51.19,0,0,0-1.77-13.29A124,124,0,0,1,377.58,247.39c-21,3.06-52.52,13.8-62.11,46.75-11,37.75-62.24,20.81-70.57,85.36A124,124,0,0,1,130.31,256.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,306.74c19.1,0,27.68-13.23,30-23.41a4.66,4.66,0,0,0-4.54-5.72h-51a4.66,4.66,0,0,0-4.54,5.72C227,293.51,235.59,306.74,254.68,306.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.75,236.59a12.77,12.77,0,1,0,12.76,12.77A12.77,12.77,0,0,0,214.75,236.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.62,262.13a12.77,12.77,0,1,0-12.77-12.77A12.77,12.77,0,0,0,294.62,262.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,404.18A210.8,210.8,0,0,0,450,180.41C407.9,72.21,285.61,18.43,177.4,60.54l6.53,16.78c99-38.51,210.79,10.66,249.3,109.62a192.77,192.77,0,0,1-42,204.68l-12.8-12.47a9.51,9.51,0,0,0-16.15,6.94l.48,33.89a9.51,9.51,0,0,0,9.62,9.37l33.89-.4a9.51,9.51,0,0,0,6.52-16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.85,431a192.44,192.44,0,0,1-60-311l11.34,11a9.51,9.51,0,0,0,16.15-6.94l-.48-33.89a9.49,9.49,0,0,0-9.62-9.37l-33.89.4A9.51,9.51,0,0,0,98.8,97.58l10.13,9.87A210.53,210.53,0,0,0,335.69,451.07l-6.52-16.77A191.29,191.29,0,0,1,181.85,431Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectTwo);
export default __webpack_public_path__ + "static/media/directTwo.5226009f4b8fb97c94d77d21c98fe023.svg";
export { ForwardRef as ReactComponent };